exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-dropdown-link[data-v-23e1099a] {\n  cursor: pointer;\n  color: #409EFF;\n}\n.el-icon-arrow-down[data-v-23e1099a] {\n  font-size: 12px;\n}\n.filter-title[data-v-23e1099a] {\n  font-weight: bolder;\n  border-bottom: 1px solid darkgray;\n}\n", ""]);

// exports
